import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { app, db } from "../Admin/Config/Config";
import { useUser } from "../Auth/UsersContext";
import {  useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
export default function Bookstore() {
  const [activeTab, setActiveTab] = useState("paperback");
  const [purchasedEbooks, setPurchasedEbooks] = useState([]);
  const [featuredBooks, setFeaturedBooks] = useState([]);
  const [newReleaseBooks, setnewReleaseBooks] = useState([]);
  const [trendingBooks, setTrendingBooks] = useState([]);
  const { user } = useUser();
// ========================= FETCH EBOOKS ========================== //
  
  const fetchEbooks = async (purchasedCourseIds) => {
    try {
      const ref = collection(db, "jaffers_english_books");
      const q = query(ref, where("status", "==", true));
      const purchased = [];
      const data = [];
      const featured = [];
      const newRelease = [];
      const trending = [];
      const ebooksSnap = await getDocs(q);
      ebooksSnap.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
        if (purchasedCourseIds.includes(doc.id)) {
          purchased.push({
            id: doc.id,
            ...doc.data(),
            isPurchased: (purchasedCourseIds || []).includes(doc.id),
          });
        }
        if (doc.data().featured_books === true ) {
          featured.push({
            id: doc.id,
            ...doc.data(),
            isPurchased: (purchasedCourseIds || []).includes(doc.id),
          });
        }
        if(doc.data().newrelease_books === true ) {
          newRelease.push({ id: doc.id, ...doc.data() });
        }
        if(doc.data().trending_books === true ) {
          trending.push({ id: doc.id, ...doc.data() });
        }
      });
      setPurchasedEbooks(purchased);
      setFeaturedBooks(featured);
      setnewReleaseBooks(newRelease);
      setTrendingBooks(trending);
    } catch (error) {
      console.error("Error fetching ebooks:", error);
    }
  };
  useEffect(() => {
    fetchEbooks(user?.je_books || []);
  }, [user]);

  // ========================= NAVIGATION FUNCTION ========================== //
  const navigate = useNavigate();
  const handleNavigation = (id) => {
    navigate(`/book-details?id=${id}`);
  };
  // ================== HANDLE PURCHASE ================== //
    const hanldePurchase = (course) => {
      const functions = getFunctions(app, "asia-south1");
     const payload = {
       study_stream: "Jaffers English",
       amount: parseFloat(course.offer_price) * 100,
       email: user?.email ?? "",
       name: user?.name ?? "",
       mobile: user?.mobile ?? "",
       uid: user?.uid ?? "",
       book_id: course.id,
       title: course.title,
       district: user?.district ?? "",
       purchase_type: "ebook",
       platform: "web"
     };
     const paymentRequest = httpsCallable(functions, "createOrderId");
      paymentRequest({
        img: course.img_url,
        orderdetails: payload,
        amount: parseFloat(course.offer_price)*100,
      }).then((result) => {
         const order = result.data;
         if (order && order !== 404) {
           const options = {
             key: process.env.REACT_APP_RAZOR_KEY,
             amount: order.amount,
             currency: order.currency,
             name: "Jaffer's English",
             description: "E-Book Purchase",
             image: course.img_url,
             order_id: order.id,
             method: {
               netbanking: true,
               card: true,
               upi: false, // 👈 this disables UPI in the Checkout form
               wallet: true,
             },
             handler: function (response) {
               window.location.reload();
             },
             prefill: {
               name: order.notes.user_name,
               email: user.email,
               contact: user.mobile,
             },
             notes: {
               address: "Razorpay Corporate Office",
             },
             theme: {
               color: "#3399cc",
             },
             modal: {
               ondismiss: function () {
                 // setloading(false);
               },
             },
           };

          try {
            const rzp1 = new window.Razorpay(options);
            rzp1.open();

            rzp1.on("payment.failed", function (response) {
              alert("Something went wrong! Try again..");
            });
          } catch (error) {
            console.error("Razorpay Error:", error);
            alert("Payment initialization failed!");
          }
         }
      });
    }


    // ================== Handle read Books ================== //
    const handleRead = (id) => {
      navigate("/viewbooks",{state:{url:id}});
    }
    const handleListView=(type,cat)=>{
          navigate(`/book-list?type=${type}&cat=${cat}`);
    }



  return (
    <div className="max-w-7xl p-4 min-h-screen">
      <div className="flex space-x-4 ml-4 mt-4">
        {["Paper Back", "E Books"].map((tab) => {
          const value = tab.toLowerCase().replace(/\s+/g, "");
          return (
            <button
              key={value}
              onClick={() => setActiveTab(value)}
              className={`px-4 py-2 text-lg font-serif rounded-xl transition-all ${
                activeTab === value
                  ? "text-white font-base bg-emerald-700 shadow-md"
                  : "text-gray-900 bg-gray-200 hover:bg-gray-300"
              }`}
            >
              {tab}
            </button>
          );
        })}
      </div>

      <div className="mt-2">
        {activeTab === "ebooks" && (
          <div>
            <br />
            <div className="flex justify-between">
              <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                Your Library
              </h1>
              {purchasedEbooks &&
              purchasedEbooks.filter((book) => book.type === "online").length >
                4 ? (
                <div
                  onClick={() => handleListView("online", "purchased")}
                  className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                >
                  View All
                </div>
              ) : null}
            </div>

            <div className="mx-auto p-4 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
              {purchasedEbooks.length > 0 ? (
                purchasedEbooks
                  .filter((book) => book.type === "online")
                  .slice(0, 4)
                  .map((book) => (
                    <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                      <img
                        src={book.img_url}
                        alt="Book Cover"
                        className="w-full h-44 mt-1 object-contain rounded "
                      />

                      <div className="flex px-1 mt-3">
                        <p className="text-white font-semibold text-lg">
                          {book.title}
                        </p>
                      </div>

                      <p className="text-gray-400 px-1 text-sm mt-2">
                        {book.book_overview.slice(0, 50)}
                      </p>
                      <div className="border-b py-2 border-gray-700"></div>
                      <div className="mt-4 flex space-x-2">
                        <div
                          onClick={() => handleRead(book.pdf_url)}
                          className="flex-1 text-center border border-gray-400 cursor-pointer bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl  transition"
                        >
                          Read Now
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="bg-black p-4 border border-gray-800 text-left rounded-2xl relative ">
                  <p className="text-white font-semibold text-lg">
                    You have not purchased any books yet.
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-between mt-6">
              {trendingBooks &&
              trendingBooks.filter((book) => book.type === "online").length >
                0 ? (
                <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                  Trending Books
                </h1>
              ) : null}
              {trendingBooks &&
              trendingBooks.filter((book) => book.type === "online").length >
                3 ? (
                <div
                  onClick={() => handleListView("online", "trending_books")}
                  className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                >
                  View All
                </div>
              ) : null}
            </div>

            <div className="mx-auto p-2 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
              {trendingBooks &&
                trendingBooks
                  .filter((book) => book.type === "online" && !book.isPurchased)
                  .slice(0, 4)
                  .map((book) => (
                    <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                      <img
                        src={book.img_url}
                        alt="Book Cover"
                        className="w-full h-44 mt-1   object-contain rounded "
                      />

                      <div className="flex  mt-3">
                        <p className="text-white   font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                          {book.title.slice(0, 20)}
                        </p>
                      </div>

                      <div className="flex  mt-2 ">
                        <p className="text-gray-500 text-sm   ">
                          {book.book_overview.slice(0, 50)}.....
                        </p>
                      </div>

                      {!book.isPurchased && (
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.price) -
                            parseFloat(book.offer_price) >
                            0 && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              ₹{" "}
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>
                      )}

                      <div className="border-b py-2 border-gray-200"></div>

                      <div className="mt-4">
                        {!book.isPurchased && (
                          <div
                            onClick={() => hanldePurchase(book)}
                            className="flex-1 text-center bg-emerald-700 text-base sm:text-xs text-white px-4 py-2 rounded-2xl  transition cursor-pointer"
                          >
                            Buy Now
                          </div>
                        )}
                        <div
                          onClick={() => handleNavigation(book.id)}
                          className="flex-1 text-center border border-gray-400 mt-3 cursor-pointer text-gray-100 text-sm px-4 py-2 rounded-2xl  transition"
                        >
                          View Details
                        </div>
                      </div>
                    </div>
                  ))}
            </div>

            <div className="flex justify-between mt-6">
              {featuredBooks &&
                featuredBooks.filter((book) => book.type === "online").length >
                  0 && (
                  <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                    Featured Books
                  </h1>
                )}
              {featuredBooks &&
              featuredBooks.filter((book) => book.type === "online").length >
                4 ? (
                <div
                  onClick={() => handleListView("online", "featured_books")}
                  className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                >
                  View All
                </div>
              ) : null}
              )
            </div>

            <div className="mx-auto p-4 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
              {featuredBooks &&
                featuredBooks
                  .filter((book) => book.type === "online" && !book.isPurchased)
                  .slice(0, 4)
                  .map((book) => (
                    <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                      <img
                        src={book.img_url}
                        alt="Book Cover"
                        className="w-full h-44 mt-1 object-contain rounded "
                      />

                      <div className="flex px-1 mt-3">
                        <p className="text-white font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                          {book.title.slice(0, 20)}
                        </p>
                      </div>

                      <p className="text-gray-500 px-1 text-sm mt-2">
                        {book.book_overview.slice(0, 50)}.....
                      </p>
                      {!book.isPurchased && (
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="ml-1">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.price) -
                            parseFloat(book.offer_price) >
                            0 && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              ₹{" "}
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>
                      )}

                      <div className="border-b py-2 border-gray-200"></div>

                      <div className="mt-4 ">
                        {!book.isPurchased && (
                          <div
                            onClick={() => hanldePurchase(book)}
                            className="flex-1 text-center bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl  transition cursor-pointer"
                          >
                            Buy Now
                          </div>
                        )}
                        <div
                          onClick={() => handleNavigation(book.id)}
                          className="flex-1 text-center border border-gray-400 mt-3 cursor-pointer text-gray-100 text-sm px-4 py-2 rounded-2xl  transition cursor-pointer"
                        >
                          View Details
                        </div>
                      </div>
                    </div>
                  ))}
            </div>

            <div className="flex justify-between mt-6">
              {newReleaseBooks &&
                featuredBooks.filter((book) => book.type === "online").length >
                  0 && (
                  <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                    New Arrivals
                  </h1>
                )}
              {newReleaseBooks &&
              newReleaseBooks.filter((book) => book.type === "online").length >
                4 ? (
                <div
                  onClick={() => handleListView("online", "newrelease_books")}
                  className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                >
                  View All
                </div>
              ) : null}
              )
            </div>

            <div className="mx-auto p-4 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
              {newReleaseBooks &&
                newReleaseBooks
                  .filter((book) => book.type === "online" && !book.isPurchased)
                  .slice(0, 4)
                  .map((book) => (
                    <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                      <img
                        src={book.img_url}
                        alt="Book Cover"
                        className="w-full h-44 mt-1 object-contain rounded "
                      />

                      <div className="flex px-1 mt-3">
                        <p className="text-white font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                          {book.title.slice(0, 20)}
                        </p>
                      </div>

                      <p className="text-gray-500 px-1 text-sm mt-2">
                        {book.book_overview.slice(0, 50)}.....
                      </p>
                      {!book.isPurchased && (
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="ml-1">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.price) -
                            parseFloat(book.offer_price) >
                            0 && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>
                      )}

                      <div className="border-b py-2 border-gray-200"></div>

                      <div className="mt-4 ">
                        {!book.isPurchased && (
                          <div
                            onClick={() => hanldePurchase(book)}
                            className="flex-1 text-center bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl  transition"
                          >
                            Buy Now
                          </div>
                        )}
                        <div
                          onClick={() => handleNavigation(book.id)}
                          className="flex-1 text-center border border-gray-400 mt-3 cursor-pointer text-gray-100 text-sm px-4 py-2 rounded-2xl  transition"
                        >
                          View Details
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        )}

        {activeTab === "paperback" && (
          <div>
            <div>
              <br />

              <div className="flex justify-between">
                {trendingBooks &&
                  trendingBooks.filter((book) => book.type === "paperback")
                    .length > 0 && (
                    <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                      Trending Books
                    </h1>
                  )}
                {trendingBooks &&
                trendingBooks.filter((book) => book.type === "paperback")
                  .length > 4 ? (
                  <div
                    onClick={() =>
                      handleListView("paperback", "trending_books")
                    }
                    className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                  >
                    View All
                  </div>
                ) : null}
              </div>
              <div className="mx-auto p-2 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
                {trendingBooks &&
                  trendingBooks
                    .filter((book) => book.type === "paperback")
                    .slice(0, 4)
                    .map((book) => (
                      <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                        <img
                          src={book.img_url}
                          alt="Book Cover"
                          className="w-full h-44 mt-1 object-contain rounded "
                        />

                        <div className="flex px-1 mt-3">
                          <p className="text-white font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                            {book.title.slice(0, 20)}
                          </p>
                        </div>

                        <p className="text-gray-500 px-1 text-sm mt-2">
                          {book.book_overview.slice(0, 50)}.....
                        </p>
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="ml-1">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.offer_price) <
                            parseFloat(book.price) && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>

                        <div className="border-b py-2 border-gray-200"></div>

                        <div className="mt-4 ">
                          <a
                            href="https://wa.me/1234567890"
                            className="flex items-center justify-center gap-2 flex-1 text-center text-xs bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl transition"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-whatsapp"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                            </svg>
                            Buy Now
                          </a>

                          <div
                            onClick={() => handleNavigation(book.id)}
                            className="flex-1 text-center border mt-3 border-gray-400 text-gray-100 text-sm px-4 py-2 rounded-2xl transition cursor-pointer"
                          >
                            View Details
                          </div>
                        </div>
                      </div>
                    ))}
              </div>

              <div className="flex justify-between mt-6">
                {featuredBooks &&
                  featuredBooks.filter((book) => book.type === "paperback")
                    .length > 0 && (
                    <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                      Featured Books
                    </h1>
                  )}
                {featuredBooks &&
                featuredBooks.filter((book) => book.type === "paperback")
                  .length > 4 ? (
                  <div
                    onClick={() =>
                      handleListView("paperback", "featured_books")
                    }
                    className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                  >
                    View All
                  </div>
                ) : null}
              </div>

              <div className="mx-auto p-4 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
                {featuredBooks &&
                  featuredBooks
                    .filter((book) => book.type === "paperback")
                    .slice(0, 4)
                    .map((book) => (
                      <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                        <img
                          src={book.img_url}
                          alt="Book Cover"
                          className="w-full h-44 mt-1 object-contain rounded "
                        />

                        <div className="flex px-1 mt-3">
                          <p className="text-white font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                            {book.title.slice(0, 20)}
                          </p>
                        </div>

                        <p className="text-gray-500 px-1 text-sm mt-2">
                          {book.book_overview.slice(0, 50)}.....
                        </p>
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="ml-1">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.offer_price) <
                            parseFloat(book.price) && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>

                        <div className="border-b py-2 border-gray-200"></div>

                        <div className="mt-4">
                          <a
                            href="https://wa.me/1234567890"
                            className="flex items-center justify-center gap-2 flex-1 text-center text-xs bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl  transition"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-whatsapp"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                            </svg>
                            Buy Now
                          </a>

                          <div
                            onClick={() => handleNavigation(book.id)}
                            className="flex-1 text-center border mt-3 border-gray-400 text-gray-100 text-sm px-4 py-2 rounded-2xl transition cursor-pointer"
                          >
                            View Details
                          </div>
                        </div>
                      </div>
                    ))}
              </div>

              <div className="flex justify-between mt-6">
                {newReleaseBooks &&
                  newReleaseBooks.filter((book) => book.type === "paperback")
                    .length > 0 && (
                    <h1 className="px-4 text-3xl font-[inter] text-emerald-700 font-bold">
                      New Arrivals
                    </h1>
                  )}
                {newReleaseBooks &&
                newReleaseBooks.filter((book) => book.type === "paperback")
                  .length > 4 ? (
                  <div
                    onClick={() =>
                      handleListView("paperback", "newrelease_books")
                    }
                    className="px-9 text-base font-[inter] underline text-emerald-700  font-bold cursor-pointer"
                  >
                    View All
                  </div>
                ) : null}
              </div>
              <div className="mx-auto p-4 max-w-7xl lg:px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
                {newReleaseBooks &&
                  newReleaseBooks
                    .filter((book) => book.type === "paperback")
                    .slice(0, 4)
                    .map((book) => (
                      <div className="bg-black p-4 border border-gray-700 text-left rounded-2xl relative shadow-md">
                        <img
                          src={book.img_url}
                          alt="Book Cover"
                          className="w-full h-44 mt-1 object-contain rounded "
                        />

                        <div className="flex px-1 mt-3">
                          <p className="text-white font-semibold text-lg truncate overflow-hidden whitespace-nowrap w-full">
                            {book.title.slice(0, 20)}
                          </p>
                        </div>

                        <p className="text-gray-500 px-1 text-sm mt-2">
                          {book.book_overview.slice(0, 50)}.....
                        </p>
                        <p className="text-gray-100  text-lg font-semibold mt-2">
                          <span className="ml-1">₹{book.offer_price}</span>
                          <span className="line-through text-red-500 text-xs ml-2">
                            ₹{book.price}
                          </span>
                          {parseFloat(book.offer_price) <
                            parseFloat(book.price) && (
                            <span
                              className="px-2 py-1 ml-1.5 bg-white text-gray-900 border text-xs font-semibold rounded 
                     inline-block sm:inline"
                            >
                              {(
                                ((parseFloat(book.price) -
                                  parseFloat(book.offer_price)) /
                                  parseFloat(book.price)) *
                                100
                              ).toFixed(0)}
                              % OFF
                            </span>
                          )}
                        </p>

                        <div className="border-b py-2 border-gray-200"></div>

                        <div className="mt-4 ">
                          <a
                            href="https://wa.me/1234567890"
                            className="flex items-center justify-center gap-2 flex-1 text-center text-xs bg-emerald-700 text-white text-sm px-4 py-2 rounded-2xl  transition"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-whatsapp"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                            </svg>
                            Buy Now
                          </a>

                          <div
                            onClick={() => handleNavigation(book.id)}
                            className="flex-1 text-center border border-gray-400 mt-3 text-gray-100 text-sm px-4 py-2 rounded-2xl  transition cursor-pointer"
                          >
                            View Details
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}






